module.exports = __webpack_public_path__ + "img/14.04bc489b.jpeg";